export const malformedRequestErrorType = "MALFORMED_REQUEST";
export const lineNumberRefusedErrorType = "LINE_NUMBER_REFUSED";
export class CrmError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
    get extensions() {
        return {
            name: this.name,
            errorType: this.errorType,
            skipReporting: this.skipReporting,
        };
    }
}
export class ArgumentNullException extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "ArgumentNullException";
        this.errorType = "ARGUMENT_NULL";
        this.skipReporting = false;
    }
}
export class BadArgumentException extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "BadArgumentException";
        this.errorType = "BAD_ARGUMENT";
        this.skipReporting = false;
    }
}
export class NotImplementedException extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "NotImplementedException";
        this.errorType = "NOT_IMPLEMENTED";
        this.skipReporting = false;
    }
}
export class InvalidConfigurationError extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "InvalidConfigurationError";
        this.errorType = "INVALID_CONFIGURATION";
        this.skipReporting = false;
    }
}
export class InvalidOperationException extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "InvalidOperationException";
        this.errorType = "INVALID_OPERATION";
        this.skipReporting = false;
    }
}
export class UnauthorizedError extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
        this.errorType = "UNAUTHORIZED";
        this.skipReporting = true;
    }
}
export class UnauthenticatedError extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "UnauthenticatedError";
        this.errorType = "UNAUTHENTICATED";
        this.skipReporting = true;
    }
}
export class PermissionsNotFoundError extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "PermissionsNotFoundError";
        this.errorType = "PERMISSIONS_NOT_FOUND";
        this.skipReporting = false;
    }
}
export class EntityNotFoundError extends CrmError {
    constructor(entityType, id) {
        super(`Could not find ${entityType} with id = ${id}`);
        this.name = "EntityNotFoundError";
        this.errorType = "NOT_FOUND";
        this.skipReporting = true;
    }
}
export class AiSummaryGenerationError extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "AiSummaryGenerationError";
        this.errorType = "AI_SUMMARY_GENERATION";
        this.skipReporting = false;
    }
}
export class AiSummaryTimeoutError extends AiSummaryGenerationError {
    constructor() {
        super(...arguments);
        this.name = "AiSummaryTimeoutError";
        this.errorType = "AI_SUMMARY_TIMEOUT";
    }
}
export class AiSummaryNotSummarizableError extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "AiSummaryNotSummarizableError";
        this.errorType = "AI_SUMMARY_NOT_SUMMARIZABLE";
        this.skipReporting = true;
    }
}
export class DocumentNotSignableError extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "DocumentNotSignableError";
        this.errorType = "DOCUMENT_NOT_SIGNABLE";
        this.skipReporting = true;
    }
}
export class MailboxSyncError extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "MailboxSyncError";
        this.errorType = "MAILBOX_SYNC";
        this.skipReporting = false;
    }
}
export class MailboxProviderUnavailableError extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "MailboxProviderUnavailableError";
        this.errorType = "MAILBOX_PROVIDER_UNAVAILABLE";
        this.skipReporting = true;
    }
}
export class LayoutError extends CrmError {
    constructor() {
        super(...arguments);
        this.name = "LayoutError";
        this.errorType = "LAYOUT_ERROR";
        this.skipReporting = false;
    }
}
//# sourceMappingURL=error.js.map